import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  PayPalScriptProvider,
  PayPalHostedFieldsProvider,
  PayPalHostedField,
  usePayPalHostedFields,
} from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "../../../../utils/paypalKeys";
import allActions from "../../../../state/actions";
import SpinnerLoading from "../../../shared/spinnerLoading/SpinnerLoading";
import ModalConfirm from "../../../shared/modalConfirm/ModalConfirm";

const CUSTOM_FIELD_STYLE = {
  border: "1px solid #606060",
  height: "40px",
  boxShadow: "2px 2px 10px 2px rgba(0,0,0,0.1)",
};
const INVALID_COLOR = {
  color: "#dc3545",
};

// Example of custom component to handle form submit
const SubmitPayment = ({
  onCardSubmit,
  spedizionePagamentoTranslation,
  checkoutTranslation,
  genericheTranslation,
  customStyle,
  user,
  currentPage,
  suffissoLang,
}) => {
  const [paying, setPaying] = useState(false);
  const cardHolderName = useRef(null);
  const hostedField = usePayPalHostedFields();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClick = () => {
    if (!hostedField?.cardFields) {
      const childErrorMessage =
        "Unable to find any child components in the <PayPalHostedFieldsProvider />";

      action(ERROR)(childErrorMessage);
      throw new Error(childErrorMessage);
    }
    const isFormInvalid =
      Object.values(hostedField.cardFields.getState().fields).some(
        (field) => !field.isValid
      ) || !cardHolderName?.current?.value;

    if (isFormInvalid) {
      return alert("The payment form is invalid");
    }
    setPaying(true);

    hostedField.cardFields
      .submit({
        // Triggering the 3D Secure
        contingencies: ["SCA_ALWAYS"],
        cardholderName: cardHolderName?.current?.value,
      })
      .then((data) => {
        const { orderId } = data;
        // Your logic to capture the transaction
        fetch(`api/responseParameters/${orderId}/`, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            intent: "capture",
            utente_id: user.userData.id,
            utente_token: user.token_id,
            currentLang: currentPage.currentLang,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            // data.result is one of the following values returned from the backend:
            // "unknown", "retry", "genericIssue", otherwise is the API Response
            let result;
            if (data.result) result = data.result;

            let retry =
              "3d Secure Failed (Request cardholder to retry): <br><br>An error occurred during the transaction. Please try again.";
            let unknownError =
              "3d Secure Failed (Do not continue with authorization):<br><br>An unknown error occurred during the transaction. Please consult your credit card issuer.";
            let success = "Transaction completed.";
            let genericIssue =
              "An issue to identify prevented the capture of the payment.";

            let res = JSON.stringify(data, null, 2);

            let resultPaypal = result;
            // Continue with authorization.
            if (
              result != "unknown" &&
              result != "retry" &&
              result != "genericIssue"
            ) {
              ModalConfirm({
                titleToShow:
                  checkoutTranslation.modalTitoloRisultatoPagamento.itemName,
                messageToShow:
                  genericheTranslation.modalmessaggioordineconclusook.itemName,
                isShowConfirmButton: false,
                isShowCanceButton: false,
                isTimerModal: true,
                onClickHandler: () => {
                  // invio a pagina finale
                  // mostro spinner
                  dispatch(allActions.isFetchingAction.loadSpinner());
                  ////const note = "";
                  ////dispatch(allActions.checkoutDetailActions.orderReset());
                  dispatch(
                    allActions.changePageActions.changePage(
                      "",
                      "paypalDetail",
                      "/paypal-ok.html",
                      history
                    )
                  );
                },
              });
            }

            // Do not continue with authorization.
            if (result === "unknown") {
              console.log(unknownError, res);
              ModalConfirm({
                titleToShow:
                  checkoutTranslation.modalTitoloRisultatoPagamento.itemName,
                messageToShow:
                  genericheTranslation.modalmessaggioordineconclusoko.itemName,
                isShowConfirmButton: false,
                isShowCanceButton: false,
                isTimerModal: true,
                onClickHandler: () => {
                  // invio a pagina finale
                  // mostro spinner
                  dispatch(allActions.isFetchingAction.loadSpinner());

                  dispatch(
                    allActions.changePageActions.changePage(
                      "",
                      "paypalDetail",
                      "/",
                      history
                    )
                  );
                },
              });
              setPaying(false);
            }
            // Do not continue with authorization. Request cardholder to retry.
            if (result === "retry") {
              console.log(retry, res);
              ModalConfirm({
                titleToShow:
                  checkoutTranslation.modalTitoloRisultatoPagamento.itemName,
                messageToShow:
                  genericheTranslation.modalmessaggioordineconclusoko.itemName,
                isShowConfirmButton: false,
                isShowCanceButton: false,
                isTimerModal: true,
                onClickHandler: () => {
                  // invio a pagina finale
                  // mostro spinner
                  dispatch(allActions.isFetchingAction.loadSpinner());

                  dispatch(
                    allActions.changePageActions.changePage(
                      "",
                      "paypalDetail",
                      "/",
                      history
                    )
                  );
                },
              });
              setPaying(false);
            }
            // An issue to identify prevented the capture of the payment.
            if (result === "genericIssue") {
              console.log(genericIssue, res);
              ModalConfirm({
                titleToShow:
                  checkoutTranslation.modalTitoloRisultatoPagamento.itemName,
                messageToShow:
                  genericheTranslation.modalmessaggioordineconclusoko.itemName,
                isShowConfirmButton: false,
                isShowCanceButton: false,
                isTimerModal: true,
                onClickHandler: () => {
                  // invio a pagina finale
                  // mostro spinner
                  dispatch(allActions.isFetchingAction.loadSpinner());

                  dispatch(
                    allActions.changePageActions.changePage(
                      "",
                      "paypalDetail",
                      "/",
                      history
                    )
                  );
                },
              });
              setPaying(false);
            }
          });
      })
      .catch((err) => {
        // Here handle error
        console.log("Payment could not be captured! ", err);
        ModalConfirm({
          titleToShow:
            checkoutTranslation.modalTitoloRisultatoPagamento.itemName,
          messageToShow:
            genericheTranslation.modalmessaggioordineconclusoko.itemName,
          isShowConfirmButton: false,
          isShowCanceButton: false,
          isTimerModal: true,
          onClickHandler: () => {
            // invio a pagina finale
            // mostro spinner
            dispatch(allActions.isFetchingAction.loadSpinner());

            dispatch(
              allActions.changePageActions.changePage(
                "",
                "paypalDetail",
                "/",
                history
              )
            );
          },
        });
        setPaying(false);
      });
  };

  const isButtonSending = paying ? "flex" : "hidden";
  const isButtonSendingCursor = paying ? "cursor-default" : "";
  const isHidePayithCard = paying ? "hidden" : "flex";

  return (
    <>
      <div className="col-span-60 p-2">
        <label title="This represents the full name as shown in the card">
          {spedizionePagamentoTranslation.cardholdername.itemName}
        </label>
        <input
          id="card-holder"
          ref={cardHolderName}
          className="card-field w-full"
          style={{ ...customStyle, outline: "none" }}
          type="text"
          placeholder="Full name"
        />
      </div>
      <div className="col-span-60  p-2">
        <button
          onClick={handleClick}
          className={`bg-ribola-congress-blue text-white font-opensanssemibold hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 w-full px-4 py-4 mt-6 ${isButtonSendingCursor}`}
          type="button"
        >
          <span
            className={`w-full items-center justify-center text-lg 3xl:text-xl ${isHidePayithCard}`}
          >
            {spedizionePagamentoTranslation.cardpaga.itemName.toUpperCase()}
            <i className="fal fa-credit-card text-2xl ml-3"></i>
          </span>
          <span
            className={`w-full items-center justify-center text-white ${isButtonSending}`}
          >
            <SpinnerLoading
              label={genericheTranslation.attendi.itemName.toUpperCase()}
            />
          </span>
        </button>
      </div>
    </>
  );
};

const PaypalForm = ({
  clientToken = "",
  fundingSource = "paypal",
  onCardSubmit = () => {},
}) => {
  const currentPage = useSelector((state) => state.currentPage);
  const suffissoLang = currentPage.currentLang.replace("_", "");
  const user = useSelector((state) => state.user);
  const order = useSelector((state) => state.order);
  const amount = order.totalCart.toFixed(2);

  const checkoutTranslation = useSelector(
    (state) => state.translations.checkout
  );
  const spedizionePagamentoTranslation = useSelector(
    (state) => state.translations.spedizionePagamento
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  useEffect(() => {}, []);

  // opzione configurazione Paypal (passo anche lingua)
  let langPaypal = `${suffissoLang}_${suffissoLang.toUpperCase()}`;
  langPaypal = langPaypal === "en_EN" ? "en_GB" : langPaypal;

  const initialOptions = {
    "client-id": PAYPAL_CLIENT_ID,
    "data-client-token": clientToken,
    components: "buttons,hosted-fields",
    intent: "capture",
    currency: "EUR",
    locale: langPaypal,
    vault: false,
  };

  return (
    <>
      {clientToken ? (
        <PayPalScriptProvider options={initialOptions}>
          <PayPalHostedFieldsProvider
            styles={{
              ".valid": { color: "#28a745" },
              ".invalid": { color: "#dc3545" },
              input: { "font-family": "monospace", "font-size": "16px" },
            }}
            createOrder={function () {
              return fetch("api/paypalOrderCreator/", {
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  purchase_units: [
                    {
                      amount: {
                        value: amount, // Here change the amount if needed
                        currency_code: "EUR", // Here change the currency if needed
                      },
                    },
                  ],
                  intent: "capture",
                  ordine_id: order.orderId,
                  utente_token: user.token_id,
                }),
              })
                .then((response) => response.json())
                .then((order) => {
                  // Your code here after create the order
                  console.log("Success Order", order);
                  return order.id;
                })
                .catch((err) => {
                  console.log("Error Order", err);
                  alert(err);
                });
            }}
          >
            <div className="grid grid-cols-60">
              <div className="col-span-60 p-2">
                <label htmlFor="card-number">
                  {spedizionePagamentoTranslation.cardnumber.itemName}
                  <span style={INVALID_COLOR}>*</span>
                </label>
                <PayPalHostedField
                  id="card-number"
                  className="card-field"
                  style={CUSTOM_FIELD_STYLE}
                  hostedFieldType="number"
                  options={{
                    selector: "#card-number",
                    placeholder: "4111 1111 1111 1111",
                  }}
                />
              </div>
              <div className="col-span-20 p-2">
                <label htmlFor="cvv">
                  {spedizionePagamentoTranslation.cardcvv.itemName}
                  <span style={INVALID_COLOR}>*</span>
                </label>
                <PayPalHostedField
                  id="cvv"
                  className="card-field"
                  style={CUSTOM_FIELD_STYLE}
                  hostedFieldType="cvv"
                  options={{
                    selector: "#cvv",
                    placeholder: "123",
                    maskInput: true,
                  }}
                />
              </div>
              <div className="col-span-40 p-2">
                <label htmlFor="expiration-date">
                  {spedizionePagamentoTranslation.cardexpirationdate.itemName}
                  <span style={INVALID_COLOR}>*</span>
                </label>
                <PayPalHostedField
                  id="expiration-date"
                  className="card-field"
                  style={CUSTOM_FIELD_STYLE}
                  hostedFieldType="expirationDate"
                  options={{
                    selector: "#expiration-date",
                    placeholder: "MM/YYYY",
                  }}
                />
              </div>
              <SubmitPayment
                onCardSubmit={onCardSubmit}
                checkoutTranslation={checkoutTranslation}
                spedizionePagamentoTranslation={spedizionePagamentoTranslation}
                genericheTranslation={genericheTranslation}
                customStyle={{
                  border: "1px solid #606060",
                  boxShadow: "2px 2px 10px 2px rgba(0,0,0,0.1)",
                }}
                user={user}
                currentPage={currentPage}
                suffissoLang={suffissoLang}
              />
            </div>
          </PayPalHostedFieldsProvider>
        </PayPalScriptProvider>
      ) : (
        <SpinnerLoading />
      )}
    </>
  );
};
export default PaypalForm;
